<template>
  <div>
    <g-header></g-header>
    <router-view></router-view>
    <g-footer></g-footer>
    <loading-mask></loading-mask>
  </div>
</template>

<script>
import GHeader from "@/components/Header";
import GFooter from "@/components/Footer";
import LoadingMask from "@/components/LoadingMask";

export default {
  name: "layout",

  components: {
    GHeader,
    GFooter,
    LoadingMask,
  },
  data: () => ({}),
  created() {
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
